import { React, forwardRef, useRef } from 'react';
import styled from 'styled-components';

// Model Import //
import PermuteView from '../../Model/Individual/AccountModel/PermuteView.js';
import CompletePermuteView from '../../Model/Individual/AccountModel/CompletePermuteView.js';

const PermutePage = forwardRef((props, ref) => {
  const PermuteRef = useRef();
  const CompleteRef = useRef();

  function permuteButtonClick() {
    PermuteRef.current.setOpacity();
    CompleteRef.current.setOpacity();
  }

  return (
    <Container>
      <PermuteView ref={PermuteRef} permuteButtonClick={permuteButtonClick}/>
      <CompletePermuteView ref={CompleteRef}/>
    </Container>
  )
});

export default PermutePage;

const Container = styled.div`
  // position: fixed;
  display: flex;

  justify-content: center;
  align-items: center;

  // gap: 132px;
  top: 0;
  left: 0;

  // width: 1920px;
  width: 100vw;
  height: 100vh;

  background-color: #FDFCFB;
`;